export const formatDashboardNumber = (n) => {
  const v = Number(n) || 0;
  return v.toLocaleString('fr-FR');
};

export const formatDashboardCa = (n) => {
  const v = Number(n) || 0;
  return `${v.toLocaleString('fr-FR', { maximumFractionDigits: 0 })} €`;
};

export const getRowLineClass = (row) => {
  if (row?._row_type === 'total') return 'is-total';
  if (row?._row_type === 'global') return 'is-global';
  return '';
};

export const PIPE_SOURCE_LABELS = {
  both: 'Commandes + Factures',
  commandes: 'Commandes uniquement',
  factures: 'Factures uniquement',
};
